<template>
  <div class="d-flex" id="wrapper">
    <ManagerSidebar :toggler.sync="isToggled" />
    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getManagerUserProfile" />

      <Message class="mr-4 ml-4 error" type="error-alert" v-show="getErrorMessage">
        <h4 slot="heading" class="alert-heading">Error</h4>
        <p slot="alert-message" class="mb-0">
          {{ getErrorMessage }}
        </p>
      </Message>

      <section id="description">
        <div class="row">
          <div class="col-md-8">
            <ManagerCandidateItemInfo :key="key" @candidateInfoUpdated="forceRerender" />
            <div class="card custom-card candidate-documents">
              <ManagerCandidateItemDocuments :header="true"/>
            </div>
          </div>
          <div class="col-md-4 d-none d-sm-block candidate-aside">
            <ManagerActivities
              :activities="currentActivities"
              @getActivities="loadMoreActivities"
              @reloadActivities="loadAcitivities"
            />
            <ManagerCandidateEmails :emails="getManagerCandidateById.emails" />
          </div>
        </div>
        <div class="row candidate-pipeline d-none d-sm-block ">
          <div class="col-md-12">
            <div class="card">
              <ManagerCandidateItemPipeline @getNewActivities="getActivities" />
            </div>
          </div>
        </div>
        <Spinner :isLoading="isLoading" />
      </section>
    </div>

    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { toggleSidebarNav } from '../../../mixins/toggleSidebarNav';
import ManagerCandidateItemInfo from '@/components/Manager/Candidates/ManagerCandidateItemInfo';
import ManagerSidebar from '@/components/Navigations/ManagerSidebar';
import TopNavbar from '../../Navigations/TopNavbar';
import ManagerActivities from '../common/ManagerActivities';
import ManagerCandidateItemPipeline from '../Candidates/ManagerCandidateItemPipeline';
import ManagerCandidateItemDocuments from '../Candidates/ManagerCandidateItemDocuments';
import ManagerCandidateEmails from '../common/ManagerEmails';

import Message from '../../AlertMessages/Message';
import { localStorageHelper } from '@/utils/helpers';
import titleMixin from '../../../mixins/titleMixin';

export default {
  components: {
    Message,
    ManagerSidebar,
    TopNavbar,
    ManagerActivities,
    ManagerCandidateItemInfo,
    ManagerCandidateItemDocuments,
    ManagerCandidateItemPipeline,
    ManagerCandidateEmails,
  },
  mixins: [toggleSidebarNav, titleMixin],
  title() {
    return this.getManagerCandidateById
      ? `${this.getManagerCandidateById.first_name} ${this.getManagerCandidateById.last_name} | Jobshark`
      : 'Candidate';
  },
  data: () => ({
    currentActivities: [],
    currentPage: 1,
    pageCount: 10,
    last_page: '',
    showModal: false,
    isToggled: false,
    isLoading: false,
    selected: [],
    isCurrentRowChecked: false,
    currentItemIds: [],
    oldIndex: '',
    newIndex: '',
    key: 0,
    isErrorMessage: false,
  }),
  methods: {
    ...mapActions('managerStoreModule', [
      'sendManagerRecent',
      'retrieveManagerUserProfile',
      'retrieveManagerCandidateById',
      'retrieveManagerCandidateActivities',
      'retrieveManagerCandidateCommentsList',
    ]),
    getActivities() {
      this.currentPage = 1;
      this.retrieveManagerCandidateActivities({
        uuid: this.$route.params.manager_candidate_id,
        page: this.currentPage,
        count: this.pageCount,
      }).then(() => {
        this.currentActivities = this.getManagerCandidateActivities.data;
        this.last_page = this.getManagerCandidateActivities.last_page;
      });
    },
    loadMoreActivities() {
      if (this.currentPage < this.last_page) {
        this.currentPage++;
        this.retrieveManagerCandidateActivities({
          uuid: this.$route.params.manager_candidate_id,
          count: this.pageCount,
          page: this.currentPage,
        }).then(() => {
          this.currentActivities = [
            ...this.currentActivities,
            ...Object.values(this.getManagerCandidateActivities.data),
          ];
        });
      }
    },
    toggleSidebarNav() {
      this.isToggled = !this.isToggled;
    },
    updateName() {
      this.candidateName = this.$route.params.candidate_name;
    },
    forceRerender() {
      this.key += 1;
      this.retrieveManagerCandidateActivities({
        uuid: this.$route.params.manager_candidate_id,
        page: 1,
        count: 10,
      });

      this.retrieveManagerCandidateById({
        manager_candidate_id: this.$route.params.manager_candidate_id,
      })
        .then(() => {
          this.isLoading = false;
          this.retrieveManagerCandidateCommentsList({
            uuid: this.$route.params.manager_candidate_id,
          });

          this.sendManagerRecent({ candidate_id: this.$route.params.manager_candidate_id });
        })
        .catch(err => {
          this.isLoading = false;
          if (err.response.status == 401) {
            localStorageHelper();

            this.$toasted.error('Your session is expired!', {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            });

            this.$router.push({ name: 'home' });
          }
        });
    },

    loadAcitivities() {
      this.retrieveManagerCandidateActivities({
        uuid: this.$route.params.manager_candidate_id,
        page: 1,
        count: 10,
      }).then(() => {
        this.currentActivities = this.getManagerCandidateActivities.data;
        this.last_page = this.getManagerCandidateActivities.last_page;
      });
    },
  },
  watch: {
    $route: 'updateName',
  },
  computed: {
    ...mapGetters('managerStoreModule', [
      'getManagerProfile',
      'getManagerUserProfile',
      'getErrorMessage',
      'getManagerCandidateActivities',
      'getManagerCandidateById',
    ]),
  },
  mounted() {
    this.isLoading = true;
    this.retrieveManagerUserProfile();
    this.loadAcitivities();

    this.retrieveManagerCandidateById({
      manager_candidate_id: this.$route.params.manager_candidate_id,
    })
      .then(() => {
        this.updateMeta();
        this.isLoading = false;
        this.retrieveManagerCandidateCommentsList({
          uuid: this.$route.params.manager_candidate_id,
        });

        this.sendManagerRecent({ candidate_id: this.$route.params.manager_candidate_id });
      })
      .catch(err => {
        this.isLoading = false;
        if (err.response.status == 401) {
          localStorageHelper();

          this.$toasted.error('Your session is expired!', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });

          this.$router.push({ name: 'home' });
        }
      });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

#description {
  padding: 0 24px;
  .card {
    margin: 0 0 24px 0 !important;
  }
}
/deep/ .scroll {
  max-height: 865px;
}

@media only screen and (max-width: 1251px) {
  #description {
    .card {
      margin: 26px 0 0 0 !important;
      border-bottom-left-radius: 18px;
      border-bottom-right-radius: 18px;
    }
  }
  .candidate-aside {
    display: none !important;
  }
}

@media only screen and (max-width: 992px) {
  #description {
    .col-md-8 {
      display: block;
      flex: 100%;
      width: 100% !important;
      max-width: 100%;
    }
    padding: 0 !important;
    .card {
      margin: 26px 0 0 0 !important;
      border-top-left-radius: 18px;
      border-top-right-radius: 18px;
    }
    .candidate-aside {
      display: none !important;
    }
    .candidate-pipeline {
      .card {
        border-radius: 0 !important;
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  #description {
    padding: 0;
    .card {
      margin: 26px 0 0 0 !important;
      border-top-left-radius: 18px;
      border-top-right-radius: 18px;
    }

    .candidate-aside {
      display: none !important;
    }
    .candidate-pipeline {
      height: 40vh !important;
      .card {
        border-radius: 0 !important;
      }
    }
  }
  .candidate-documents {
    height: 20vh !important;
  }
}

@media only screen and (max-width: 576px) {
  #description {
    padding: 0;
    .card {
      margin: 0 0 24px 0 !important;
    }
  }
  #description {
    padding: 0;

    .card.candidate-documents {
      display: none!important;
      height: 520px !important;
      min-height: 520px !important;
      max-height: 520px !important;
    }
  }

  .error {
    margin: 5px 0 10px 0;
  }
}
</style>
